<va-mat-table>
  <mat-table #table [dataSource]="dataSource">
    <ng-container matColumnDef="header-row">
      <mat-header-cell *matHeaderCellDef>
        {{ 'USERS.BULK_IMPORT.IMPORT_MAPPER.COLUMNS' | translate }}
      </mat-header-cell>
      <mat-cell [matTooltip]="col.headerRow" *matCellDef="let col">
        <span class="mobile-label">
          {{ 'USERS.BULK_IMPORT.IMPORT_MAPPER.COLUMNS' | translate }}
        </span>
        <span class="ellipsis">{{ col.headerRow }}</span>
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="first-row">
      <mat-header-cell *matHeaderCellDef>
        {{ 'USERS.BULK_IMPORT.IMPORT_MAPPER.FIRST_ROW' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let col">
        <span class="mobile-label">
          {{ 'USERS.BULK_IMPORT.IMPORT_MAPPER.FIRST_ROW' | translate }}
        </span>
        {{ col.firstRow }}
      </mat-cell>
    </ng-container>
    <ng-container matColumnDef="mapping">
      <mat-header-cell *matHeaderCellDef>
        {{ 'USERS.BULK_IMPORT.IMPORT_MAPPER.MAP_TO' | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let col">
        <app-bulk-import-mapper-row [headerRow]="col.headerRow"></app-bulk-import-mapper-row>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
  </mat-table>
</va-mat-table>

<mat-list class="errors" *ngIf="errors$ | async as errors">
  <div>
    <strong>
      {{ 'USERS.BULK_IMPORT.IMPORT_MAPPER.ERRORS_ON_FOLLOWING_ROWS' | translate }}
    </strong>
  </div>
  <mat-list-item *ngFor="let error of errors">
    <span href="#" class="span-tag tag">
      {{ 'USERS.BULK_IMPORT.IMPORT_MAPPER.ROW_NUMBER' | translate: { rowNumber: error.row } }}
      ({{ error.column }}) {{ error.message }}
    </span>
  </mat-list-item>
  <a *ngIf="show < errors?.length" (click)="increaseShow()">
    {{ 'USERS.BULK_IMPORT.IMPORT_MAPPER.SHOW_MORE' | translate }}
  </a>
  <section>
    <mat-checkbox class="example-margin" [(ngModel)]="proceedWithErrors">
      {{ 'USERS.BULK_IMPORT.IMPORT_MAPPER.SKIP_ROWS_WITH_ERRORS' | translate }}
    </mat-checkbox>
    <div>
      <mat-hint>
        {{ 'USERS.BULK_IMPORT.IMPORT_MAPPER.DOWNLOAD_CSV_WITH_INCOMPLETE_ACCOUNTS' | translate }}
      </mat-hint>
    </div>
    <mat-error *ngIf="!proceedWithErrors">*{{ 'COMMON.REQUIRED' | translate }}</mat-error>
  </section>
  <a *ngIf="errors?.length > 0" href="/manage-accounts/import-list/business-categories-csv" target="_blank">
    <mat-icon color="primary">save_alt</mat-icon>
    <span class="downloadLink">
      {{ 'USERS.BULK_IMPORT.DOWNLOAD_BUSINESS_CATEGORIES' | translate }}
    </span>
  </a>
</mat-list>

<div class="map-buttons">
  <mat-error
    class="error mapperError"
    *ngIf="errorMessage$ | async as errorMessage"
    innerHTML="{{ errorMessage }}"
  ></mat-error>
  <button
    mat-stroked-button
    color="secondary"
    matStepperPrevious
    type="button"
    data-action="clicked-back-field-mapper-bulk-import"
  >
    {{ 'COMMON.ACTION_LABELS.BACK' | translate }}
  </button>
  <button
    [disabled]="uploading$ | async"
    mat-flat-button
    type="button"
    color="primary"
    (click)="uploadFileAndMapping()"
    style="vertical-align: top"
    data-testid="upload-file-and-mapping"
    data-action="clicked-next-field-mapper-bulk-import"
  >
    <span *ngIf="(uploading$ | async) === false">
      {{ 'COMMON.ACTION_LABELS.NEXT' | translate }}
    </span>
    <mat-spinner class="processing-spinner" *ngIf="uploading$ | async" [diameter]="30"></mat-spinner>
  </button>
</div>
